;(function () {
	const swiperInstances = new Map()
	const lightboxInstances = new Map()

	const toBoolean = (value) => value === 'true' || value === true

	const getModalForSection = (sectionRoot) => {
		const modalId = sectionRoot.dataset.modalId
		return modalId ? document.getElementById(modalId) : null
	}

	const destroySlider = (sectionId, sectionRoot) => {
		const swiperEl = sectionRoot.querySelector('.asymmetric-gallery__swiper')
		const swiper = swiperInstances.get(sectionId)
		if (swiper && typeof swiper.destroy === 'function') {
			swiper.destroy(true, true)
			swiperInstances.delete(sectionId)
		}
		if (swiperEl) {
			swiperEl.classList.remove('swiper-initialized')
		}
	}

	const destroyLightbox = (sectionId, sectionRoot) => {
		const modal = getModalForSection(sectionRoot)
		const lightboxEl = modal?.querySelector('.asymmetric-gallery__lightbox-swiper')
		const lightbox = lightboxInstances.get(sectionId)
		if (lightbox && typeof lightbox.destroy === 'function') {
			lightbox.destroy(true, true)
			lightboxInstances.delete(sectionId)
		}
		if (lightboxEl) {
			lightboxEl.classList.remove('swiper-initialized')
		}
	}

	const syncMainSliderToImage = (sectionRoot, imageIndex) => {
		const sectionId = sectionRoot.dataset.id
		const main = swiperInstances.get(sectionId)
		if (!main) return

		const perPanel = +sectionRoot.dataset.imagesPerPanel || 5
		const panelIndex = Math.floor(imageIndex / perPanel)
		if (Number.isNaN(panelIndex)) return

		if (main.params.loop) {
			main.slideToLoop(panelIndex)
		} else {
			main.slideTo(panelIndex)
		}
	}

	const initLightbox = (sectionRoot) => {
		const sectionId = sectionRoot.dataset.id
		if (!sectionId || lightboxInstances.has(sectionId)) return null

		const modal = getModalForSection(sectionRoot)
		const lightboxEl = modal?.querySelector('.asymmetric-gallery__lightbox-swiper')
		if (!lightboxEl || !modal || typeof Swiper === 'undefined') return null

		const slideCount = lightboxEl.querySelectorAll('.swiper-slide').length
		if (slideCount <= 0) return null

		const nextEl = modal.querySelector('.asymmetric-gallery__lightbox-next')
		const prevEl = modal.querySelector('.asymmetric-gallery__lightbox-prev')

		const swiperParams = {
			slidesPerView: 1,
			spaceBetween: 0,
			loop: slideCount > 1,
			keyboard: {
				enabled: true,
				onlyInViewport: false,
			},
			navigation:
				slideCount > 1 && nextEl && prevEl
					? {
							nextEl,
							prevEl,
						}
					: undefined,
			on: {
				slideChange(swiper) {
					if (!modal.hasAttribute('open')) return
					syncMainSliderToImage(sectionRoot, swiper.realIndex)
				},
			},
		}

		const lightboxSwiper = new Swiper(lightboxEl, swiperParams)
		lightboxInstances.set(sectionId, lightboxSwiper)

		if (!sectionRoot.dataset.lightboxBound) {
			sectionRoot.dataset.lightboxBound = 'true'
			sectionRoot.addEventListener('click', (event) => {
				const trigger = event.target.closest('[data-lightbox-index]')
				if (!trigger || !sectionRoot.contains(trigger)) return

				const activeModal = getModalForSection(sectionRoot)
				const activeLightbox = lightboxInstances.get(sectionId)
				const index = +trigger.dataset.lightboxIndex
				if (!activeModal || Number.isNaN(index)) return

				if (activeLightbox && slideCount > 1) {
					if (activeLightbox.params.loop) {
						activeLightbox.slideToLoop(index, 0)
					} else {
						activeLightbox.slideTo(index, 0)
					}
				}

				syncMainSliderToImage(sectionRoot, index)
				activeModal.show(trigger)
			})
		}

		return lightboxSwiper
	}

	const initSlider = (sectionRoot) => {
		const sectionId = sectionRoot.dataset.id
		if (!sectionId || swiperInstances.has(sectionId)) return

		const swiperEl = sectionRoot.querySelector('.asymmetric-gallery__swiper')
		if (!swiperEl || typeof Swiper === 'undefined') return

		const panelCount = +sectionRoot.dataset.panelCount
		if (panelCount <= 1) return

		const speed = +sectionRoot.dataset.speed * 1000
		const delay = +sectionRoot.dataset.delay * 1000
		const autoplay = toBoolean(sectionRoot.dataset.autoplay)
		const stopAutoplay = toBoolean(sectionRoot.dataset.stopAutoplay)
		const gridGap = Math.max(0, +sectionRoot.dataset.gridGap || 0)

		let autoplayParam = {}
		if (autoplay) {
			autoplayParam = {
				autoplay: {
					delay,
					pauseOnMouseEnter: stopAutoplay,
					disableOnInteraction: false,
				},
			}
		}

		const swiper = new Swiper(swiperEl, {
			speed,
			slidesPerView: 'auto',
			slidesPerGroup: 1,
			spaceBetween: gridGap,
			loop: true,
			autoHeight: false,
			keyboard: true,
			navigation: {
				nextEl: `#${sectionId} .asymmetric-gallery__nav .swiper-button-next`,
				prevEl: `#${sectionId} .asymmetric-gallery__nav .swiper-button-prev`,
			},
			pagination: {
				el: `#${sectionId} .asymmetric-gallery__counter`,
				type: 'custom',
				renderCustom: function (_swiper, current, total) {
					return current + ' - ' + total
				},
			},
			...autoplayParam,
		})

		swiperInstances.set(sectionId, swiper)
	}

	const syncSection = (sectionRoot) => {
		const sectionId = sectionRoot.dataset.id
		if (!sectionId) return

		destroySlider(sectionId, sectionRoot)
		destroyLightbox(sectionId, sectionRoot)
		initLightbox(sectionRoot)
		initSlider(sectionRoot)
	}

	const initAsymmetricGallery = () => {
		const boot = () => {
			document.querySelectorAll('.asymmetric-gallery').forEach((sectionRoot) => {
				syncSection(sectionRoot)
			})
		}

		if (typeof customElements !== 'undefined' && customElements.whenDefined) {
			customElements.whenDefined('modal-dialog').then(boot)
		} else {
			boot()
		}
	}

	initAsymmetricGallery()
	window.addEventListener('load', initAsymmetricGallery)

	document.addEventListener('shopify:section:load', initAsymmetricGallery)
	document.addEventListener('shopify:section:unload', (event) => {
		const sectionRoot = event.target.querySelector('.asymmetric-gallery')
		if (!sectionRoot) return
		const sectionId = sectionRoot.dataset.id
		destroySlider(sectionId, sectionRoot)
		destroyLightbox(sectionId, sectionRoot)
	})
})()
